module.exports = __webpack_public_path__ + "static/img/SV.ce443716.jpg";